<template>
    <div class="wrapper padding-sm bg-white">
        <div class="flex align-start justify-between margin-bottom">
            <h3 class="page-title line-height">会员证书</h3>
            <el-button class="blue-btn" round type="primary" @click="$router.go(-1)">返回
            </el-button>
        </div>


        <el-image v-if="certificate" :src="imgUrl + certificate" alt="" class="certificate">
            <div slot="error">
                <el-empty description="暂无证书"></el-empty>
            </div>
        </el-image>

        <el-form class="form margin-top" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto"  v-if="!readonly">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item prop="cert_name" label="证书名称">
                        <el-input v-model="ruleForm.cert_name" placeholder="请输入证书名称"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="cert_code" label="证书编号">
                        <el-input v-model="ruleForm.cert_code" placeholder="请输入证书编号"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item prop="cert_company" label="发证单位">
                        <el-input v-model="ruleForm.cert_company" placeholder="请输入发证单位"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="cert_date" label="发证时间">
                        <el-date-picker
                            v-model="ruleForm.cert_date"
                            placeholder="请选择发证时间"
                            style="width: 100%"
                            value-format="timestamp"
                            type="date">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item prop="cert_content" label="证书内容">
                <el-input v-model="ruleForm.cert_content" placeholder="请输入证书内容" type="textarea" resize="none"
                          :autosize="{ minRows: 6, maxRows: 6 }">
                </el-input>
            </el-form-item>
        </el-form>
        <div class="flex align-center justify-center" v-if="!readonly">
            <el-button class="blue-btn"  :loading="loading" @click="submitForm('ruleForm')">
                提交信息
            </el-button>
        </div>
    </div>
</template>

<script>
import {memberCertificate,getUserCertDetail,upUserCertDetail} from "@/api/organiz";
import {IMAGE_PATH} from "@/config";
import {custom_certificate} from "@/utils/const";

export default {
    name: "certificate",
    data() {
        return {
            certificate: '',
            noCertificate: false,
            loading: false,
            ruleForm: {
                cert_name: '',
                cert_code: '',
                cert_company: '',
                cert_date: '',
                cert_content: '',
            },
            rules: {
                cert_name: [
                    {required: true, message: '请输入证书名称', trigger: 'blur'},
                ],
                cert_code: [
                    {required: true, message: '请输入证书编号', trigger: 'blur'},
                ],
                cert_company: [
                    {required: true, message: '请输入发证单位', trigger: 'blur'},
                ],
                cert_date: [
                    {required: true, message: '请选择发证时间', trigger: 'blur'},
                ],
                cert_content: [
                    {required: true, message: '请输入证书内容', trigger: 'blur'},
                    {min: 5, message: '意见建议至少为 5 个字符', trigger: 'blur'}
                ]
            },
            readonly:true
        }
    },

    created() {
        this.$emit('setIndex', [3, 0], '会员证书')
        this.readonly = custom_certificate(this.$store.state.user.mid)
        this.init()
        this.getCertificate()
    },
    computed: {
        imgUrl() {
            return IMAGE_PATH
        },
    },
    components: {},
    methods: {
        async init() {
            let _data = await getUserCertDetail(this.$route.params.id)
            if (_data.status === 200) {
                this.ruleForm.cert_name = _data.data.cert_name
                this.ruleForm.cert_code = _data.data.cert_code
                this.ruleForm.cert_company = _data.data.cert_company
                this.ruleForm.cert_date = _data.data.cert_date ? _data.data.cert_date * 1000 : ''
                this.ruleForm.cert_content = _data.data.cert_content
            }
        },
        async getCertificate() {
            let _data = await memberCertificate(this.$route.params.id)
            if (_data.status === 200) {
                this.certificate = _data.data + '?v=' + new Date().getTime()
            } else {
                this.noCertificate = true
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.upUserCertDetail();
                }
            });
        },
        async upUserCertDetail(){
            this.loading = true
            let _data = await upUserCertDetail(this.$route.params.id, this.ruleForm.cert_name, this.ruleForm.cert_content,
                this.ruleForm.cert_code, this.ruleForm.cert_company, this.ruleForm.cert_date / 1000)
            this.loading = false
            if (_data.status === 200) {
                this.$message.success(_data.msg)
                this.getCertificate()
            }
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.certificate {
    width: 100%;
}
</style>